import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAppSelector } from '../../hooks';
import Panel from '../../components/Panel/Panel';
import './Vip.css';

export function Vip() {
  const expiresAt = useAppSelector(state => state.character.vipExpiresAt ?? 0);
  const [now, setNow] = useState(Date.now());
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [expiresAt]);
  const active = expiresAt > now;
  return <>
    <button className={`vip-launcher ${active ? 'vip-active' : 'vip-inactive'}`} aria-label="VIP" title="สมาชิก VIP" onClick={() => setOpen(true)}>
      <img src="/assets/ui/vip/vipi.png" alt="VIP" />
    </button>
    {open && createPortal(<div className="vip-backdrop" role="dialog" aria-modal="true" aria-label="สิทธิพิเศษ VIP">
      <Panel name="หมายเหตุ · VIP" moveable={false} onClose={() => setOpen(false)} style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 31001 }}>
        <div className="vip-details">
          <header className="vip-hero"><div><span className="vip-eyebrow">PkNiN · VIP</span><h2>สิทธิพิเศษสำหรับคุณ</h2><p>สนุกได้เต็มที่ พร้อมสิทธิ์ที่มากกว่า</p></div><img className="vip-details-logo" src="/assets/ui/vip/vipi.png" alt="" /></header>
          <div className="vip-membership">
          <p>สถานะ VIP: <strong className={active ? 'vip-status-active' : 'vip-status-inactive'}>{active ? 'เปิดใช้งานแล้ว' : 'ยังไม่เปิดใช้งาน'}</strong></p>
          {active && <p className="vip-expiry">หมดอายุ {new Date(expiresAt).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok' })}</p>}
          </div>
          <h3>สิทธิพิเศษสำหรับสมาชิก VIP</h3>
          <ol>
            <li>เกิดฟรีได้ทันที ไม่ต้องรอคูลดาวน์ ได้ HP/MP 30% หรือจ่าย 50 คูปองเพื่อเกิดพร้อม HP/MP 100% (ผู้เล่นทั่วไป 100 คูปอง)</li>
            <li>ข้ามฉากต่อสู้ด้วย Skip เพียง 10 คูปอง</li>
            <li>EXP จากการฆ่ามอนสเตอร์เพิ่ม 20% ไม่รวมลาสโนเชสและ EXP กิจกรรม</li>
            <li>ซื้อไอเท็มจากร้านค้าของเกมและอัปเกรดอุปกรณ์ ลดค่าใช้จ่าย 20%</li>
            <li>ฟื้นฟู VP ประจำวันเพิ่มอีก 20 แต้ม</li>
            <li>เมื่อถูกโจมตีระหว่างออฟไลน์ แพ้เสียคะแนนเพียง 50% ชนะได้คะแนน 1.5 เท่า</li>
            <li>หากถูกโจมตีตอนออฟไลน์จน HP, MP หรือ VP หมด เมื่อล็อกอินจะฟื้นทั้งสามหลอดเต็ม 100%</li>
          </ol>
          <p className="vip-card-note">ใช้บัตร VIP ในกระเป๋าเพื่อเปิดใช้งานหรือต่ออายุ · มีบัตร 3, 7 และ 30 วัน</p>
          <button className="vip-close" onClick={() => setOpen(false)}>ปิด</button>
        </div>
      </Panel>
    </div>, document.body)}
  </>;
}
